import axios from 'axios';
import store from '../store/store'

export default function setup() {
  axios.interceptors.request.use(request => {   
    store.commit('setLoading', true)

    return request;

  }, (err) => {
    return Promise.reject(err);
  });
  
  axios.interceptors.response.use(response => {    
    store.commit('setLoading', false)

    if(response.data.status && response.data.status.length > 0){
      store.commit('setStatusMessages', response.data.status)
    } else {
      store.commit('setStatusMessages', [])
    }

    return response;
  }, (err) => {
      return Promise.reject(err);
  });
}